function _templateObject11() {
  var data = _taggedTemplateLiteral(["\n  margin-top: 0.3625rem;\n  color: ", ";\n  font-size: 0.723rem;\n  text-transform: uppercase;\n"]);

  _templateObject11 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10() {
  var data = _taggedTemplateLiteral(["\n  ", " {\n    height: 0.375rem;\n  }\n\n  ", " {\n    display: none;\n  }\n"]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = _taggedTemplateLiteral(["\n  height: 3.125rem;\n  vertical-align: middle;\n"]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n  width: auto;\n\n  ", " {\n    position: relative;\n    background-color: ", ";\n\n    ", " {\n      left: -100%;\n      height: 0;\n      transition: left 200ms ease-in-out;\n    }\n\n    .header__logo {\n      position: absolute;\n      left: 20vw;\n      transition: left 0.2s ease-in-out;\n      top: 0.6125rem;\n      height: 2.25rem;\n      visibility: hidden;\n    }\n\n    &.header__container--opened {\n      ", " {\n        height: 100vh;\n        overflow-y: auto;\n        left: 0;\n      }\n\n      .header__tools {\n        display: none;\n      }\n\n      .header__logo {\n        left: calc(50vw - 3.125rem);\n        visibility: visible;\n      }\n    }\n  }\n\n  ", " {\n    background-color: ", ";\n  }\n"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n  ", " {\n    display: none;\n  }\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  height: 3.5rem;\n\n  ", " {\n    position: relative;\n    height: 3.5rem;\n  }\n\n  ", " {\n    height: 6.5rem;\n    ", " {\n      display: none;\n    }\n  }\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  font-size: ", ";\n  font-weight: ", ";\n  text-transform: uppercase;\n  margin-left: 0.5rem;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n\n  ", " {\n    display: none;\n  }\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  margin-left: auto;\n\n  ", " {\n    display: none;\n  }\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  display: none;\n  flex-direction: row;\n  align-items: center;\n  margin-left: auto;\n  align-self: flex-start;\n\n  ", " {\n    display: flex;\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n\n  ", " {\n    margin-left: auto;\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-flow: column;\n\n  ", " {\n    flex-flow: row;\n    align-items: center;\n    margin: 0.5rem 2rem;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

import { Strip } from "../strip/Strip.styles";
import styled, { from, to } from "../../theme";
import { Link } from "../link/Link";
import { HeaderNavWrapper } from "./headerNav/HeaderNav.styles";
import { HeaderNavToggleWrapper } from "./headerNavToggle/HeaderNavToggle.styles";
export var HeaderContent = styled.div(_templateObject(), from('lg'));
export var HeaderMobileContent = styled.div(_templateObject2(), from('lg'));
export var HeaderDesktopTools = styled.div(_templateObject3(), from('lg'));
export var HeaderMobileTools = styled.div(_templateObject4(), from('lg'));
export var ActiveName = styled.span(_templateObject5(), function (props) {
  return props.theme.variables.fonts.size.base;
}, function (props) {
  return props.theme.variables.fonts.weight.bold;
}, from('lg'));
export var HeaderWrapper = styled.header(_templateObject6(), to('lg'), from('lg'), HeaderNavToggleWrapper);
export var LogoLink = styled(Link)(_templateObject7(), to('lg'));
export var HeaderContainer = styled.div(_templateObject8(), to('lg'), function (props) {
  return props.theme.variables.colors.white;
}, HeaderNavWrapper, HeaderNavWrapper, from('lg'), function (props) {
  return props.theme.variables.colors.white;
});
export var Logo = styled.img(_templateObject9());
export var HeaderStrip = styled(Strip)(_templateObject10(), from('md'), from('lg'));
export var EnvInfo = styled.div(_templateObject11(), function (props) {
  return props.theme.variables.colors.darkGrey;
});